
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function LiveGameScore (props) {
    return Template.default.apply({props}); //eslint-disable-line no-undef
}
LiveGameScore.defaultProps = {
    isDualscreen: 'false'
};
LiveGameScore.propTypes = {
    game: PropTypes.object.isRequired,
    sportAlias: PropTypes.string.isRequired,
    isDualscreen: PropTypes.string
};

export default LiveGameScore;